<template>
  <Wrapper
      code="delivery_pickup"
      :icon="ICONS.pickup"
      :model-value="attrs.ADDRESS"
      @open="onClick"
      label="Подразделение"
  >
    {{ currentPickupOffice ? currentPickupOffice.NAME : 'выберите подразделение' }}
  </Wrapper>
</template>

<script lang="ts" setup>

import {VOrderSectionProps, vorderSectionPropsDefault} from "./util";
import Wrapper from "./Wrapper/Wrapper.vue";
import {storeToRefs} from "pinia";
import {ICONS} from "@/assets/icons";
import {useRouter} from "vue-router"
import {useVorderState} from "@/modules/shop/store/vorder-state";

const vorderState = useVorderState()
const {attrs, currentPickupOffice} = storeToRefs(vorderState)

const props = withDefaults(defineProps<VOrderSectionProps>(), {
  ...vorderSectionPropsDefault,
})

const router = useRouter()

const onClick = () => {
  router.push('/delivery-service?role=vorder&type=pickup')
}

</script>

<style>

</style>
